import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

const CostomDateFilter = ({ open, handleClose, setDates, dates }) => {
    return (
        <Dialog open={open} handleClose={handleClose} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm">
            <DialogTitle>
                <span>Custom Date Filter</span>
            </DialogTitle>
            <DialogContent>
                <div className="resColRow">
                    <div className="pdngXS">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                fullWidth
                                label="from"
                                size="small"
                                inputVariant="outlined"
                                value={dates?.from}
                                onChange={(d) =>
                                    setDates({ ...dates, from: new Date(d).setHours(0, 0, 0, 0).valueOf(), dateType: "custom" })
                                }
                                animateYearScrolling
                                placeholdertext="from"
                                format="dd/MM/yyyy"
                                maxDate={new Date()}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div className="pdngXS">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                fullWidth
                                label="to"
                                size="small"
                                inputVariant="outlined"
                                value={dates?.to}
                                onChange={(d) =>
                                    setDates({ ...dates, to: new Date(d).setHours(23, 59, 59, 998).valueOf(), dateType: "custom" })
                                }
                                animateYearScrolling
                                placeholdertext="to"
                                format="dd/MM/yyyy"
                                maxDate={new Date()}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                </div>
                <DialogActions>
                    <Button color="primary" onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};
export default CostomDateFilter;
